import { render, staticRenderFns } from "./ReportOtorgamientoRep.vue?vue&type=template&id=300b8368&"
import script from "./ReportOtorgamientoRep.vue?vue&type=script&lang=ts&"
export * from "./ReportOtorgamientoRep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports